export default __webpack_public_path__ + "static/media/sec3.b31e1c60.jpg";